import { Navigate } from "react-router-dom";
import { useAuthContext } from "./auth/AuthContext";
import { UserRole } from "./auth/types/user";

const RootRedirects: React.FC = () => {
  const { user, hasRole } = useAuthContext();
  const userIsUnVerified = user?.state === "CREATED";
  const userIsNotApproved = user?.state === "PENDING";

  /* User is not logged in, redirect to login */
  if (!user) return <Navigate to="/login" />;

  if (userIsUnVerified) return <Navigate to="/verify" />;

  if (userIsNotApproved) return <Navigate to="/pendingapproval" />;

  if (hasRole([UserRole.PAYROLL])) return <Navigate to="/reports" />;

  if (hasRole([UserRole.EXTERNAL_INSTALLER])) return <Navigate to="/assigned-orders" />;

  return <Navigate to="/dashboard" replace />;
};

export default RootRedirects;
